import * as React from "react";
import { ApolloProvider } from "react-apollo";
import { ThemeProvider } from "emotion-theming";
import "modern-normalize/modern-normalize.css";
import SettingsContext from "../contexts/settings-context";
import Loader from "../components/loader";
import client from "../api/client";
import settings from "../config/settings";
import theme from "../config/theme";
import "./app.css";

const Home = React.lazy(() => import("../scenes/home"));
const Station = React.lazy(() => import("../scenes/station"));
const FileList = React.lazy(() => import("../scenes/file-list/file-list"));

interface AppProps {
  fileList?: string;
  slug?: string;
}

const App: React.FC<AppProps> = ({ slug, fileList }) => (
  <React.Suspense fallback={<Loader />}>
    <ThemeProvider theme={theme}>
      <SettingsContext.Provider value={settings}>
        <ApolloProvider client={client}>
          {fileList ? <FileList /> : slug ? <Station slug={slug} /> : <Home />}
        </ApolloProvider>
      </SettingsContext.Provider>
    </ThemeProvider>
  </React.Suspense>
);

export default App;
